import React, { useState, useEffect } from 'react';
import Header from './HeaderHome';
import Footer from './FooterHome';

const Homepage = () => {

    const carouselImages = [
        'assets/home_images/banner/banner.png',
        'assets/home_images/banner/banner2.png',
        'assets/home_images/banner/banner3.png',
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const touchStartX = React.useRef(null);
    const touchEndX = React.useRef(null);

    const goToPrev = () => {
        setCurrentIndex((prev) =>
            prev === 0 ? carouselImages.length - 1 : prev - 1
        );
    };

    const goToNext = () => {
        setCurrentIndex((prev) =>
            (prev + 1) % carouselImages.length
        );
    };

    // Auto slide
    useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(() => {
            setCurrentIndex((prev) =>
                (prev + 1) % carouselImages.length
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [isPaused]);
    // ── Service data ──
    const services = [
        {
            icon: "👵",
            title: "Care for Senior Citizens",
            desc: "Providing assistance, essential supplies, emotional support, and healthcare aid to elderly people who need love and care.",
            link: "/care-for-senior-citizens",
        },
        {
            icon: "👧",
            title: "Child Welfare",
            desc: "Supporting underprivileged children through educational assistance, nutrition, school supplies, and opportunities for a brighter future.",
            link: "/child-welfare",
        },
        {
            icon: "♿",
            title: "Support for Persons with Disabilities",
            desc: "Extending financial and material assistance, mobility aids, and rehabilitation support to differently-abled individuals.",
            link: "/disability-support",
        },
        {
            icon: "🏥",
            title: "Health & Medical Assistance",
            desc: "Helping economically disadvantaged patients with medical treatment, medicines, health camps, and emergency healthcare support.",
            link: "/health-medical",
        },
        {
            icon: "🎓",
            title: "Education for Poor Students",
            desc: "Providing scholarships, school bags, books, uniforms, stationery, and other educational necessities to deserving students.",
            link: "/education-for-poor",
        },
        {
            icon: "🌳",
            title: "Environment & Nature Conservation",
            desc: "Promoting a greener tomorrow through tree plantation drives, environmental awareness programmes, and nature preservation initiatives.",
            link: "/environment-conservation",
        },
        {
            icon: "🤝",
            title: "Community Service",
            desc: "Organising relief activities, social welfare programmes, awareness campaigns, and humanitarian initiatives to uplift communities.",
            link: "/community-service",
        },
    ];

    const stories = [
        {
            img: "assets/home_images/latest_events/anna.png",
            title: "A Meal and a Smile for Our Childrens",
            desc: "How our childrens care program brought warmth and dignity.",
            link: "/child-welfare",
        },
        {
            img: "assets/home_images/latest_events/1.jpeg",
            title: "A School Bag, A Dream, A Future",
            desc: "Education support that helped a young girl from a rural village stay in school and aspire to become a teacher.",
            link: "/education-for-poor",
        },
        {
            img: "assets/home_images/latest_events/camp2.png",
            title: "Health Camp Brings Hope to a Remote Village",
            desc: "Over 200 people received free medical checkups and medicines through our mobile health initiative.",
            link: "/health-medical",
        },
    ];

    const events = [
        { img: "assets/home_images/latest_events/1.jpeg", title: "School bag distribution drive for underprivileged children." },
        { img: "assets/home_images/latest_events/2.jpeg", title: "School bag distribution drive for underprivileged." },
        { img: "assets/home_images/latest_events/3.jpeg", title: "School bag distribution drive for underprivileged." },
        { img: "assets/home_images/latest_events/4.jpeg", title: "School bag distribution drive for underprivileged." },
        { img: "assets/home_images/latest_events/5.jpeg", title: "School bag distribution drive for underprivileged." },
        { img: "assets/home_images/latest_events/6.jpeg", title: "School bag distribution drive for underprivileged." },

        { img: "assets/home_images/latest_events/8.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/9.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/10.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/11.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/12.jpg", title: "Children Engaging in Cultural Activities." },

        { img: "assets/home_images/latest_events/14.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/15.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/16.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/17.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/18.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/19.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/20.jpg", title: "Children Engaging in Cultural Activities." },
        { img: "assets/home_images/latest_events/21.jpg", title: "Children Engaging in Cultural Activities." },

    ];

    return (
        <div className="App">
            <Header />

            {/* ========== HERO ========== */}
            {/* <section
                className="hero-section relative text-white"
                style={{ backgroundImage: "url('assets/home_images/banner/banner.png')" }}
            ></section> */}

            {/* <section className="hero-section">
                <picture>
                    <source
                        media="(max-width:768px)"
                        srcSet="assets/home_images/banner/banner.png"
                    />
                    <img
                        src="assets/home_images/banner/banner.png"
                        alt="Venkatadri Seva Trust"
                        className="w-full h-full object-cover"
                    />
                </picture>
            </section> */}
            <section
                className="relative w-full overflow-hidden bg-black"
                onTouchStart={(e) => {
                    touchStartX.current = e.touches[0].clientX;
                    setIsPaused(true);
                }}
                onTouchMove={(e) => {
                    touchEndX.current = e.touches[0].clientX;
                }}
                onTouchEnd={() => {
                    if (
                        touchStartX.current !== null &&
                        touchEndX.current !== null
                    ) {
                        const distance =
                            touchStartX.current - touchEndX.current;

                        // Swipe left → next
                        if (distance > 50) {
                            goToNext();
                        }

                        // Swipe right → previous
                        if (distance < -50) {
                            goToPrev();
                        }
                    }

                    touchStartX.current = null;
                    touchEndX.current = null;

                    setTimeout(() => {
                        setIsPaused(false);
                    }, 1000);
                }}
            >
                {/* Slides */}
                <div
                    className="
            relative
            w-full
            h-[220px]
            xs:h-[240px]
            sm:h-[320px]
            md:h-[400px]
            lg:h-[500px]
        "
                >
                    {carouselImages.map((src, index) => (
                        <div
                            key={src}
                            className={`
                    absolute inset-0
                    transition-opacity
                    duration-700
                    ease-in-out
                    ${index === currentIndex
                                    ? 'opacity-100 z-[1]'
                                    : 'opacity-0 z-0'
                                }
                `}
                        >
                            <img
                                src={src}
                                alt={`Venkatadri Seva Trust Slide ${index + 1}`}
                                className="
                        w-full
                        h-full
                        
                        object-center
                        select-none
                        pointer-events-none
                    "
                                draggable="false"
                            />

                            {/* Optional dark overlay */}
                            <div className="absolute inset-0 bg-black/10"></div>
                        </div>
                    ))}

                    {/* Previous Button */}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            goToPrev();
                        }}
                        className="
                absolute
                left-2 sm:left-4
                top-1/2
                -translate-y-1/2
                z-20

                flex
                items-center
                justify-center

                w-8 h-8
                sm:w-10 sm:h-10
                md:w-12 md:h-12

                rounded-full

                bg-black/50
                hover:bg-black/75

                text-white

                transition-all
                duration-300

                active:scale-90
            "
                        aria-label="Previous slide"
                    >
                        <svg
                            className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>

                    {/* Next Button */}
                    <button
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            goToNext();
                        }}
                        className="
                absolute
                right-2 sm:right-4
                top-1/2
                -translate-y-1/2
                z-20

                flex
                items-center
                justify-center

                w-8 h-8
                sm:w-10 sm:h-10
                md:w-12 md:h-12

                rounded-full

                bg-black/50
                hover:bg-black/75

                text-white

                transition-all
                duration-300

                active:scale-90
            "
                        aria-label="Next slide"
                    >
                        <svg
                            className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M9 5l7 7-7 7"
                            />
                        </svg>
                    </button>

                    {/* Dots */}
                    <div
                        className="
                absolute
                bottom-3 sm:bottom-4
                left-1/2
                -translate-x-1/2
                z-20

                flex
                items-center
                gap-2
            "
                    >
                        {carouselImages.map((_, index) => (
                            <button
                                key={index}
                                type="button"
                                onClick={() => {
                                    setCurrentIndex(index);
                                    setIsPaused(true);

                                    setTimeout(() => {
                                        setIsPaused(false);
                                    }, 1000);
                                }}
                                className={`
                        transition-all
                        duration-300
                        rounded-full

                        ${index === currentIndex
                                        ? `
                                    w-6
                                    sm:w-8
                                    h-2
                                    bg-white
                                `
                                        : `
                                    w-2
                                    h-2
                                    bg-white/50
                                    hover:bg-white
                                `
                                    }
                    `}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </section>
            <section className="py-12">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">
                        Watch Our Work in Action
                    </h2>
                    <p className="text-center text-white mb-8 max-w-2xl mx-auto">
                        See how your support is transforming lives – from healthcare camps to education drives and community outreach.
                    </p>
                    <div className="max-w-3xl mx-auto">
                        <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                                src="https://www.youtube.com/embed/jRbfCk-5nfs"
                                title="Venkatadri Seva Trust - Our Impact"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </section>

            {/* ========== SERVICE AREAS ========== */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <div className="text-center mb-12">
                        <h2 className="text-3xl md:text-4xl font-bold text-white">
                            Our Areas of Service
                        </h2>
                        <p className="text-yellow-100 mt-2 text-lg">
                            Reaching out with love, dignity, and hope
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {services.map((service, idx) => (
                            <div
                                key={idx}
                                className="service-card bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-smooth text-center border-t-4 border-primary"
                            >
                                <div className="service-icon">
                                    <span>{service.icon}</span>
                                </div>
                                <h3 className="text-xl font-semibold text-gray-800">
                                    {service.title}
                                </h3>
                                <p className="text-gray-600 mt-2 text-sm">{service.desc}</p>
                                <a
                                    href={service.link}
                                    className="inline-block mt-4 text-primary font-medium hover:underline text-sm"
                                >
                                    Learn more →
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ========== IMPACT STORIES ========== */}
            <section className="py-16 bg-primary text-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
                        Our Impact Stories
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {stories.map((story, idx) => (
                            <div
                                key={idx}
                                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-smooth story-card text-gray-800"
                            >
                                <img
                                    src={story.img}
                                    alt={story.title}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="p-4">
                                    <h3 className="text-xl font-semibold">{story.title}</h3>
                                    <p className="text-gray-600 mt-2 line-clamp-3">{story.desc}</p>
                                    <a
                                        href={story.link}
                                        className="inline-block mt-3 text-primary font-medium hover:underline"
                                    >
                                        Read More →
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-8">
                        <a href="/overview" className="text-white font-semibold hover:underline">
                            View All Stories <i className="fas fa-arrow-right ml-1"></i>
                        </a>
                    </div>
                </div>
            </section>

            {/* ========== EVENTS ========== */}
            <section className="py-16">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">
                        Latest Events
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {events.map((event, idx) => (
                            <div
                                key={idx}
                                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-smooth border-l-4 border-primary"
                            >
                                <img
                                    src={event.img}
                                    alt="Event"
                                    className="w-full h-40 object-cover rounded"
                                />
                                <p className="text-gray-600 mt-3 font-medium">{event.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Homepage;